import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, LazyLoadEvent, MessageService} from 'primeng/api';
import {ActivatedRoute, Router} from '@angular/router';
import {VendorService} from '../../../shared/services/vendors/vendor.service';
import {CreateVendorComponent} from '../create-vendor/create-vendor.component';
import {VirtualScroller} from 'primeng/virtualscroller';
import {AppTableKeysData} from '../../../shared/enums/app-table-keys-data';
import {AppEnumConstants} from '../../../shared/enums/app-enum-constants';
import {TableSupportBase} from '../../../shared/utility/table-support-base';
import {VendorFilterDto} from '../../../shared/dto/vendor/vendor-filter-dto';
import {VendorListDto} from '../../../shared/dto/vendor/vendor-list-dto';
import {AppConstant} from '../../../shared/utility/app-constant';
import {NotificationService} from '../../../shared/services/notification/notification.service';
import {PoService} from '../../../shared/services/po/po.service';
import {BillsService} from '../../../shared/services/bills/bills.service';
import {PrivilegeService} from '../../../shared/services/privilege.service';
import {AppAuthorities} from '../../../shared/enums/app-authorities';
import {VendorInvoiceComponent} from '../vendor-invoice/vendor-invoice.component';
import {VendorPaymentComponent} from '../vendor-payment/vendor-payment.component';
import {VendorPoComponent} from '../vendor-po/vendor-po.component';
import {VendorGrnComponent} from '../vendor-grn/vendor-grn.component';
import {FormGuardService} from '../../../shared/guards/form-guard.service';
import {VendorItemListComponent} from '../item/vendor-item-list/vendor-item-list.component';
import {VendorDetailViewComponent} from '../vendor-detail-view/vendor-detail-view.component';
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {AppAnalyticsConstants} from "../../../shared/enums/app-analytics-constants";

export class VendorState {
  public activeTab?: any;
}


@Component({
  selector: 'app-vendor-home',
  templateUrl: './vendor-home.component.html',
  styleUrls: ['./vendor-home.component.scss']
})
export class VendorHomeComponent implements OnInit, OnDestroy, AfterViewInit {

  public vendorState: VendorState = new VendorState();

  public tableSupportBase = new TableSupportBase();
  public invoice = true;
  public vendorInfo = true;
  public tabIndex: number;
  public fromNotification = false;
  public clickedVendor: any;
  public isOpenEditPage = false;
  public filterValues: VendorFilterDto = new VendorFilterDto();
  public vendorList: VendorListDto[] = [];
  public items;
  public vendorName: any;
  public vendorId: any;
  public screenHeight: number;
  public firstVendor: any;
  public appAuthorities = AppAuthorities;
  public appEnumConstants = AppEnumConstants;
  public isVendorCreateTab = false;
  public isVendorInvitationTab = false;
  public isVendorGroupTab = false;

  @ViewChild('vs') vs: VirtualScroller;
  @ViewChild('createVendorComponent') createVendorComponent: CreateVendorComponent;
  @ViewChild('vendorInvoiceComponent') vendorInvoiceComponent: VendorInvoiceComponent;
  @ViewChild('vendorBillPaymentComponent') vendorBillPaymentComponent: VendorPaymentComponent;
  @ViewChild('vendorPurchaseOrder') vendorPurchaseOrder: VendorPoComponent;
  @ViewChild('vendorPoReceiptComponent') vendorPoReceiptComponent: VendorGrnComponent;
  @ViewChild('vendorItemListComponent') vendorItemListComponent: VendorItemListComponent;
  @ViewChild('vendorDetailViewComponent') vendorDetailViewComponent: VendorDetailViewComponent;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight - 208;
  }

  constructor(public router: Router, public billsService: BillsService, public privilegeService: PrivilegeService,
              public poService: PoService, private messageService: MessageService, public vendorService: VendorService,
              public route: ActivatedRoute, public notificationService: NotificationService,
              public gaService: GoogleAnalyticsService,
              public confirmationService: ConfirmationService, public formGuardService: FormGuardService, public el: ElementRef) {
  }

  ngOnInit(): void {
    this.onResize();
    this.route.params.subscribe(params => {
      if (params.data){
        params = JSON.parse(atob(params.data));
      }
      if (params.id && params.status) {
        this.tabIndex = 2;
        this.fromNotification = true;
        return;
      }
      if (params.tab !== undefined) {
        this.fromNotification = true;
        this.tabIndex = parseInt(params.tab);
      }
    });

    if (sessionStorage.getItem('vendor-list')) {
      this.vendorState = JSON.parse(sessionStorage.getItem('vendor-list'));
      this.tabIndex = this.vendorState.activeTab;
    } else {
      this.tabIndex = 0;
    }

    this.route.params.subscribe(params => {
      if (params.tab !== undefined) {
        this.tabChanged(parseInt(params.tab), null);
      }
    });
  }

  /**
   * This method can be used to create vendor
   */
  createVen() {
    this.isOpenEditPage = false;
    this.vendorInfo = false;
  }


  loadData(event: LazyLoadEvent) {
    this.tableSupportBase.searchFilterDto = event;
  }


  ngOnDestroy() {
    sessionStorage.removeItem(AppTableKeysData.VENDOR_STATE_KEY);
  }

  refreshVendorList(id?, object?) {
    this.filterValues.rows = 30;
    if (object) {
      id = object.id;
    }
    if (this.clickedVendor.id === id) {
      this.vs.scrollToIndex(0);
    }
    this.vendorService.searchVendors(this.filterValues).subscribe((res: any) => {
        if (res.status === AppConstant.HTTP_RESPONSE_STATUS_SUCCESS) {
          this.vendorList = Array.from({length: res.body.totalRecords});
          const loadedProducts = res.body.data;

          Array.prototype.splice.apply(this.vendorList, [
            ...[0, 30],
            ...loadedProducts
          ]);
          if (this.clickedVendor.id === id) {
            this.firstVendor = this.vendorList[0];
          }

        } else {
          this.notificationService.infoMessage(res.body.message);
        }
      }, (error => {
        this.notificationService.errorMessage(error);
      })
    );
  }

  /**
   * This method can be used store data in storage
   */
  storeSessionStore() {
    this.vendorState.activeTab = this.tabIndex;
    sessionStorage.setItem('vendor-list', JSON.stringify(this.vendorState));
  }

  tabChanged(tabIndex: any, event) {
    this.tabIndex = tabIndex;

    const actionNames = [
      AppAnalyticsConstants.VENDOR,
      AppAnalyticsConstants.VENDOR_INVITATIONS,
      AppAnalyticsConstants.VENDOR_REQUESTS,
      AppAnalyticsConstants.VENDOR_GROUPS,
      AppAnalyticsConstants.COMMUNITY_VENDOR
    ];
    const actionName = actionNames[tabIndex] || '';
    this.gaService.trackScreensNavigationEvents(
      actionName,
      AppAnalyticsConstants.VENDOR
    );

    this.storeSessionStore();
    this.checkActiveTab(event, false, null);
  }

  isSendInvitationEnabled() {
    return this.privilegeService.isAuthorizedMultiple([this.appAuthorities.VENDORS_SEND_VENDOR_INVITATION,
      this.appAuthorities.VENDORS_DELETE_VENDOR_INVITATION, this.appAuthorities.VENDORS_RESEND_VENDOR_INVITATION]);
  }

  isVendorRequestEnabled() {
    return this.privilegeService.isAuthorizedMultiple([this.appAuthorities.VENDORS_APPROVE_VENDOR_REQUEST,
      this.appAuthorities.VENDORS_DELETE_VENDOR_REQUEST, this.appAuthorities.VENDORS_REJECT_VENDOR_REQUEST]);
  }

  isVendorGroupEnabled() {
    return this.privilegeService.isAuthorizedMultiple([this.appAuthorities.VENDOR_GROUP_CREATE,
      this.appAuthorities.VENDOR_GROUP_EDIT, this.appAuthorities.VENDOR_GROUP_DELETE, this.appAuthorities.VENDOR_GROUP_INACTIVATE,
      this.appAuthorities.VENDOR_GROUP_ACTIVATE]);
  }

  isCommunityVendorsEnabled() {
    return this.privilegeService.isAuthorized(this.appAuthorities.VENDORS_ADD_TO_LOCAL_VENDOR_LIST);
  }

  ngAfterViewInit(): void {
    const activeTab = this.el.nativeElement.querySelector('.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link');
    this.checkActiveTab(null, true, activeTab.innerText);
  }

  /**
   * This method is used to get active tab header
   * @param tabView value come from shortcut key directive
   * @param isInitialState value come from shortcut key directive
   * @param initialTab value come from shortcut key directive
   */
  checkActiveTab(tabView, isInitialState, initialTab) {
    const activeTab = isInitialState ? initialTab : (tabView?.originalEvent?.target?.innerText ?? '');

    this.isVendorCreateTab = activeTab === AppEnumConstants.VENDORS_TAB;
    this.isVendorInvitationTab = activeTab === AppEnumConstants.VENDOR_INVITATIONS;
    this.isVendorGroupTab = activeTab === AppEnumConstants.VENDOR_GROUP_TAB;
  }

}

